import { IconButton } from "@design";
import { ArrowLeft } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Text } from "@/components/Text";

/** Where the picker is: a back button (when there's somewhere to go back to) and the path, the last part current. */
export function PickerPath({ crumbs, onBack }: Readonly<{ crumbs: string[]; onBack?: () => void }>) {
  const { t } = useTranslation("chat", { keyPrefix: "cloud" });
  const parents = crumbs.slice(0, -1);
  return (
    <div className="flex min-w-0 items-center gap-2">
      {onBack && <IconButton icon={<ArrowLeft />} aria-label={t("up")} variant="ghost" size="sm" onClick={onBack} />}
      <Text variant="body-sm" tone="tertiary" className="truncate">
        {parents.map((crumb) => `${crumb} / `).join("")}
        <Text as="span" variant="body-sm">
          {crumbs.at(-1)}
        </Text>
      </Text>
    </div>
  );
}
